import ky from "ky";
import {
  IAppointment,
  IAppointmentRoutingGenesysCloudQueue,
  IScheduleAppointmentRequest,
} from "../../models/schedule/IAppointment";
import {
  IScheduleRequest,
  IScheduleResponse,
  IScheduleSecurity,
} from "../../models/schedule/ISchedule";
import { IScheduleService } from "../../models/schedule/IScheduleService";
import { AppConfigService as Config } from "../app.config.service";
import moment from "moment";

export class GenesysAppointmentService implements IScheduleService {
  constructor() {}

  async create(
    request: IScheduleRequest,
    security: IScheduleSecurity
  ): Promise<IScheduleResponse> {
    try {
      const routing: IAppointmentRoutingGenesysCloudQueue = {
        type: undefined,
        properties: {
          deploymentId: Config.pcDeploymentId,
          pcEnvironment: Config.pcEnvironment,
          chatMode: Config.chatMode,
        },
      };

      switch (Config.chatMode) {
        case "genesys-cloud":
        case "genesys-api":
        case "genesys-premise":
          routing.type = "GENESYS_CLOUD_QUEUE";
          routing.properties.queueName =
            Config.pcCallbackQueueName || Config.pcQueue;
          break;
        case "genesys-web-messaging":
          routing.type = "GENESYS_CLOUD_FLOW";
          break;
      }

      const schedule: IScheduleAppointmentRequest = {
        ...request,
        interaction: {
          routing,
        },
        customer: {
          ...request.customer,
          contact: {
            ...request.customer.contact,
            primaryPhone:
              request.customer.contact.primaryPhoneCountryCode +
              request.customer.contact.primaryPhone.trim(),
          },
        },
        metadata: {
          ...request.metadata,
          ...request.customer.metadata,
        },
        notificationHeaders: Config.appointmentNotificationHeaders,
        applicationId: Config.applicationId,
        timezone: Config.schedule.timeZone,
        duration: moment
          .duration(Config.scheduleIntervalMinutes, "minutes")
          .toISOString(),
        locale: Config.locale,
      };

      const basicToken = btoa(
        [
          request.customer.contact.primaryPhoneCountryCode +
            request.customer.contact.primaryPhone.trim(),
          security.verificationCode,
          security.otp,
        ].join(":")
      );

      const response = await ky
        .post(`${Config.auviousBaseUrl}/api/appointments/basic`, {
          json: schedule,
          headers: {
            Authorization: `Basic ${basicToken}`,
          },
        })
        .json<IAppointment<IAppointmentRoutingGenesysCloudQueue>>();

      return { scheduleEntityId: response.id, request };
    } catch (ex) {
      throw ex;
    }
  }
}
